module.exports = __webpack_public_path__ + "img/women-with-tab.83bf24f7.png";